import {BrickContext, ActionBrick, ErrorFlow, registerBrick, File as OFile, Transaction, CloudObject} from 'olympe';
import Compressor from "compressorjs";

export default class CompressPicture extends ActionBrick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {File} file
     * @param {number} width
     * @param {number} height
     * @param {boolean} persist
     * @param {function()} forwardEvent
     * @param {function(File)} setReducedFile
     * @param {function(*)} setErrorFlow
     */
    update($, [file, width, height, persist], [forwardEvent, setReducedFile, setErrorFlow]) {

        if (!file) {
            setErrorFlow(ErrorFlow.create('No file provided', 404));
            return;
        }

        if(!width && !height) {
            setErrorFlow(ErrorFlow.create('No output width or height provided, cannot compress the image', 400));
            return;
        }

        // Read file data
        file.getContentAsBinary (
            (content) => {
                const mimeType = file.get(OFile.mimeTypeProp);
                const filename = file.get(OFile.fileNameProp);
                new Compressor(new Blob([content], {type: mimeType}), {
                    height: height,
                    width: width,
                    success: async (result) => {
                        const transaction = new Transaction(persist);
                        const fileTag = transaction.create(OFile);
                        OFile.setContent(transaction, fileTag, filename, await result.arrayBuffer(), mimeType);

                        // Execute transaction
                        transaction.execute().then(() => {
                            // On success set new result image
                            setReducedFile(CloudObject.get(fileTag));
                            forwardEvent();
                        }).catch((e) => {
                            setErrorFlow(ErrorFlow.create(`Failed to create ImageFile object with compressed image file: ${e}`, 502));
                        });
                    }, error: (e) => {
                        setErrorFlow(ErrorFlow.create(`Failed to compress image file: ${e}`, 501));
                    },
                });
            },
            (errorMsg) => {
                setErrorFlow(ErrorFlow.create(`Failed to fetch content url: ${errorMsg}`, 500));
            }
        );
    }
}

registerBrick('018f51b17e525910c779', CompressPicture);
